import { render, staticRenderFns } from "./questionIndex.vue?vue&type=template&id=89f5aae6&scoped=true"
import script from "./questionIndex.vue?vue&type=script&lang=js"
export * from "./questionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f5aae6",
  null
  
)

export default component.exports